import { useLayoutEffect, useRef, useState } from 'react';

// Drop-in <img> replacement that shows a shimmer placeholder until the image
// decodes, then fades it in. Reserves space via aspect-ratio to avoid layout
// shift. Pass `fill` when the image lives in a fixed-size object-fit:cover box.
export default function SmartImage({
  className = '',
  wrapperClassName = '',
  fill = false,
  style,
  width,
  height,
  onLoad,
  onError,
  ...rest
}) {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useLayoutEffect(() => {
    const img = ref.current;
    if (img && img.complete && img.naturalWidth > 0) setLoaded(true);
  }, []);

  const handleLoad = (e) => {
    setLoaded(true);
    onLoad?.(e);
  };

  const handleError = (e) => {
    setLoaded(true);
    onError?.(e);
  };

  const wrapperStyle = { ...style };
  // Reserve space with the declared ratio only while loading (prevents layout
  // shift). Once loaded, release it so the actual image dimensions decide height.
  if (!fill && width && height && !loaded) {
    wrapperStyle.aspectRatio = `${width} / ${height}`;
  }

  const wrapperClasses =
    'smart-img' +
    (fill ? ' smart-img--fill' : '') +
    (loaded ? ' is-loaded' : '') +
    (wrapperClassName ? ` ${wrapperClassName}` : '');

  return (
    <span className={wrapperClasses} style={wrapperStyle}>
      <img
        ref={ref}
        className={className}
        width={width}
        height={height}
        onLoad={handleLoad}
        onError={handleError}
        {...rest}
      />
    </span>
  );
}
